import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import {
  Calendar,
  MapPin,
  Users,
  Globe,
  Award,
} from "lucide-react"
const EventInformation: React.FC = () => {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-foreground mb-12">Informasi Kegiatan</h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-blue-600" />
                </div>
                <CardTitle className="text-blue-600">Konferensi</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  8 track konferensi internasional dengan tema pendidikan, sains, teknologi, dan humaniora
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-16 h-16 bg-amber-100 dark:bg-amber-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Globe className="w-8 h-8 text-amber-600" />
                </div>
                <CardTitle className="text-amber-600">Konvensi</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Konvensi nasional dengan 12 LPTK untuk merumuskan kebijakan pendidikan masa depan
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="w-8 h-8 text-green-600" />
                </div>
                <CardTitle className="text-green-600">Eksebisi</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Pameran inovasi pendidikan, teknologi pembelajaran, dan produk riset terbaru
                </p>
              </CardContent>
            </Card>

            <Card className="text-center hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MapPin className="w-8 h-8 text-purple-600" />
                </div>
                <CardTitle className="text-purple-600">Rekreasi</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground text-sm">
                  Wisata budaya Bali, kunjungan ke tempat bersejarah, dan pengalaman kuliner lokal
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Detailed Event Schedule */}
          <div className="grid lg:grid-cols-2 gap-8">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Calendar className="w-5 h-5 text-primary" />
                  Rundown Acara Utama
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-20 text-sm font-medium text-blue-600 flex-shrink-0">08:00</div>
                    <div>
                      <p className="font-medium text-foreground">Registration & Welcome Coffee</p>
                      <p className="text-sm text-muted-foreground">Pendaftaran peserta dan networking</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-20 text-sm font-medium text-blue-600 flex-shrink-0">09:00</div>
                    <div>
                      <p className="font-medium text-foreground">Opening Ceremony</p>
                      <p className="text-sm text-muted-foreground">Pembukaan resmi KONASPI XII</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-20 text-sm font-medium text-blue-600 flex-shrink-0">10:00</div>
                    <div>
                      <p className="font-medium text-foreground">Keynote Speaker</p>
                      <p className="text-sm text-muted-foreground">Presentasi dari pakar pendidikan nasional</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-20 text-sm font-medium text-blue-600 flex-shrink-0">11:00</div>
                    <div>
                      <p className="font-medium text-foreground">Parallel Sessions</p>
                      <p className="text-sm text-muted-foreground">8 track konferensi berjalan paralel</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-20 text-sm font-medium text-blue-600 flex-shrink-0">15:00</div>
                    <div>
                      <p className="font-medium text-foreground">Pleno & Closing</p>
                      <p className="text-sm text-muted-foreground">Sesi pleno dan penutupan</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-secondary" />
                  Fasilitas & Akomodasi
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <h4 className="font-medium text-foreground mb-2">Venue Konferensi</h4>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Auditorium Utama (kapasitas 1000 orang)</li>
                      <li>• 8 ruang paralel untuk track conference</li>
                      <li>• Area eksebisi dan pameran</li>
                      <li>• Fasilitas audio-visual modern</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground mb-2">Akomodasi</h4>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Hotel berbintang di Singaraja</li>
                      <li>• Guest house kampus</li>
                      <li>• Homestay tradisional Bali</li>
                      <li>• Shuttle service tersedia</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium text-foreground mb-2">Wisata Tambahan</h4>
                    <ul className="text-sm text-muted-foreground space-y-1">
                      <li>• Pura Ulun Danu Beratan</li>
                      <li>• Air Terjun Sekumpul</li>
                      <li>• Desa Tradisional Tenganan</li>
                      <li>• Pantai Lovina (dolphin watching)</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventInformation;
